import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  _PhoneNumber___get_raw__impl__gc2pmp2jq67zyqivc5w as _PhoneNumber___get_raw__impl__gc2pmp,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  toPhoneNumber2boyry1jrtl94 as toPhoneNumber,
  _PhoneNumber___init__impl__slwhzy3axmmryqebui0 as _PhoneNumber___init__impl__slwhzy,
  _EmailAddress___get_raw__impl__6ose226bwkbm01ev3l as _EmailAddress___get_raw__impl__6ose2,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  toEmailAddress1e4w5ykg7qyos as toEmailAddress,
  _EmailAddress___init__impl__a6ugvr3polh9vbc2yo8 as _EmailAddress___init__impl__a6ugvr,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  StringsForLanguage_English_getInstance2jm5ip12elsyk as StringsForLanguage_English_getInstance,
} from '../../strings.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Issuef8rh7nn7wz0o as Issue } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  MutableValidated2ognu5vxf17ur as MutableValidated,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function withStringBuffer(_this__u8e3s4, getStr) {
  var tmp;
  if (getStr === VOID) {
    tmp = withStringBuffer$lambda;
  } else {
    tmp = getStr;
  }
  getStr = tmp;
  var buffer = MutableRemember().new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(false, VOID, VOID, VOID, ($this$MutableRemember) => getStr($this$MutableRemember.invoke_r7m7el_k$(_this__u8e3s4)));
  return new (withStringBuffer$2())(buffer, _this__u8e3s4);
}
function withStringBuffer_0(_this__u8e3s4, getStr) {
  var tmp;
  if (getStr === VOID) {
    tmp = withStringBuffer$lambda_0;
  } else {
    tmp = getStr;
  }
  getStr = tmp;
  var buffer = MutableRemember().new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(false, VOID, VOID, VOID, ($this$MutableRemember) => getStr($this$MutableRemember.invoke_r7m7el_k$(_this__u8e3s4)));
  return new (withStringBuffer$4())(buffer, _this__u8e3s4);
}
function withStringBuffer$lambda(it) {
  var tmp = it;
  var tmp0_safe_receiver = tmp == null ? null : tmp.raw_1;
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (PhoneNumber())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = _PhoneNumber___get_raw__impl__gc2pmp(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : takeLast(tmp1_safe_receiver, 10);
  return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
}
var withStringBuffer$2Class;
function withStringBuffer$2() {
  if (withStringBuffer$2Class === VOID) {
    class $ {
      constructor($buffer, $this_withStringBuffer) {
        this.$buffer_1 = $buffer;
        this.$this_withStringBuffer_1 = $this_withStringBuffer;
        this.$$delegate_0__1 = $buffer;
        this.node_1 = $this_withStringBuffer.get_node_wor8sr_k$().child$default_s9je3b_k$();
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      *set_851sqp_k$(value, $completion) {
        try {
          yield* this.$this_withStringBuffer_1.set_revjhg_k$(new (PhoneNumber())(toPhoneNumber(value)), $completion);
          this.node_1.report_ins8zt_k$(null);
          this.$buffer_1.reset_5u6xz3_k$();
        } catch ($p) {
          if ($p instanceof IllegalArgumentException()) {
            var _unused_var__etf5q3 = $p;
            var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
            this.node_1.report_ins8zt_k$(new (Issue())((tmp0_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp0_elvis_lhs).get_validationInvalidPhoneMessage_cvge1e_k$(), VOID, false));
            yield* this.$this_withStringBuffer_1.set_revjhg_k$(new (PhoneNumber())(_PhoneNumber___init__impl__slwhzy('')), $completion);
            // Inline function 'com.lightningkite.reactive.extensions.value' call
            this.$buffer_1.valueSet_aujvv6_k$(value);
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      set_revjhg_k$(value, $completion) {
        return this.set_851sqp_k$((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE(), $completion);
      }
      get_state_6o3fgk_k$() {
        return this.$$delegate_0__1.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_6o3fgk_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableValidated(), Reactive()], [1]);
    withStringBuffer$2Class = $;
  }
  return withStringBuffer$2Class;
}
function withStringBuffer$lambda_0(it) {
  var tmp = it;
  var tmp0_safe_receiver = tmp == null ? null : tmp.raw_1;
  var tmp_0;
  var tmp_1 = tmp0_safe_receiver;
  if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
    tmp_0 = null;
  } else {
    tmp_0 = _EmailAddress___get_raw__impl__6ose2(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
var withStringBuffer$4Class;
function withStringBuffer$4() {
  if (withStringBuffer$4Class === VOID) {
    class $ {
      constructor($buffer, $this_withStringBuffer) {
        this.$buffer_1 = $buffer;
        this.$this_withStringBuffer_1 = $this_withStringBuffer;
        this.$$delegate_0__1 = $buffer;
        this.node_1 = $this_withStringBuffer.get_node_wor8sr_k$().child$default_s9je3b_k$();
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      *set_851sqp_k$(value, $completion) {
        try {
          yield* this.$this_withStringBuffer_1.set_revjhg_k$(new (EmailAddress())(toEmailAddress(value)), $completion);
          this.node_1.report_ins8zt_k$(null);
          this.$buffer_1.reset_5u6xz3_k$();
        } catch ($p) {
          if ($p instanceof IllegalArgumentException()) {
            var _unused_var__etf5q3 = $p;
            var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
            this.node_1.report_ins8zt_k$(new (Issue())((tmp0_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp0_elvis_lhs).get_validationInvalidEmailMessage_1bjpq8_k$(), VOID, false));
            yield* this.$this_withStringBuffer_1.set_revjhg_k$(new (EmailAddress())(_EmailAddress___init__impl__a6ugvr('')), $completion);
            // Inline function 'com.lightningkite.reactive.extensions.value' call
            this.$buffer_1.valueSet_aujvv6_k$(value);
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      set_revjhg_k$(value, $completion) {
        return this.set_851sqp_k$((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE(), $completion);
      }
      get_state_6o3fgk_k$() {
        return this.$$delegate_0__1.get_state_wc71uu_k$();
      }
      get_state_wc71uu_k$() {
        return this.get_state_6o3fgk_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableValidated(), Reactive()], [1]);
    withStringBuffer$4Class = $;
  }
  return withStringBuffer$4Class;
}
//region block: exports
export {
  withStringBuffer as withStringBuffer3khj76irczpue,
  withStringBuffer_0 as withStringBufferw9sv07w4j3wo,
};
//endregion

//# sourceMappingURL=validation.mjs.map
